// Edit action builder. Only composed into the action list when the
// signed-in user is the message sender — the host row enforces that
// gate; the builder simply describes the affordance.

import { Pencil } from "lucide-react";

import type { MessageAction } from "~/components/MessageActions";

export function buildEditAction(params: {
  onClick: () => void;
  disabled?: boolean;
}): MessageAction {
  return {
    id: "edit",
    label: "Edit",
    icon: Pencil,
    onClick: params.onClick,
    disabled: params.disabled,
  };
}
